import axios from 'lib/axios';

const validateDiscount = async (value) => {
  const { data } = await axios.post('/customer/discount/validate', value);
  return data;
};

const getActiveDiscount = async (value) => {
  const { data } = await axios.post('/customer/discount/active',value);
  return data;
};

export { validateDiscount, getActiveDiscount};
